// extracted by mini-css-extract-plugin
export var wordContainer = "_rl-0";